import React from 'react';
import { Link } from 'react-router-dom';
export const Logo = ({
  className = ''
}: {
  className?: string;
}) => {
  return <Link to="/" className={`flex items-center ${className}`} data-id="element-280">
      <div className="flex flex-col items-center justify-center bg-gradient-to-r from-brand-blue to-brand-teal rounded-md w-8 h-8 text-white font-bold mr-2" data-id="element-281">
        <span className="text-xs" data-id="element-282">DS</span>
      </div>
      <span className="text-xl font-bold bg-gradient-to-r from-brand-blue to-brand-teal bg-clip-text text-transparent" data-id="element-283">
        Daily Serve
      </span>
    </Link>;
};